import bowser from 'bowser'
import isInternetExplorer from 'is-iexplorer'

const isProduction = process.env.NODE_ENV === 'production'
const isDevelopment = process.env.NODE_ENV === 'development'

export default {
  autoCompleteIndices: {
    certifications: 'certification',
    companies: 'company',
    industrySimple: 'industrySimple',
    jobTitles: 'jobTitles',
    majors: 'major',
    primaryIndustry: 'industry',
    skills: 'skill',
    universityDim: 'university',
    universityDisplay: 'university',
  },
  building_icon_url: `${process.env.REACT_APP_PUBLIC_BUCKET}building-light.png`,
  isProduction,
  isDevelopment,
  isIE: isInternetExplorer,
  isLowerThanIE11: bowser.msie && bowser.version < 11,
  annual_increase_no_degree: 0.005,
  annual_increase_degree: 0.03,
  tax_rate_no_degree: 0.05,
  tax_rate_degree: 0.15,
  default_profile_picture_url: `${process.env.REACT_APP_PROFILE_PICTURE_URL_PREFIX}ChooseProfileImage.png`,
  stripe_plan_ids: {
    INDIVIDUAL: 'sku_individual',
    PARENT: 'sku_parent_99',
  },
  stripe_plan_amounts: {
    INDIVIDUAL: 49,
    PARENT: 99,
  },
  possibleUserTypesUniversity: [
    {
      displayName: 'Student',
      value: 'coll_student',
    },
    {
      displayName: 'Faculty/Staff',
      value: 'admin',
    },
    {
      displayName: 'Alum',
      value: 'alum',
    },
  ],
  possibleUserTypesApp: {
    collegeStudent: {
      displayName: 'College Student',
      value: 'coll_student',
    },
    highschoolStudent: {
      displayName: 'High School Student',
      value: 'hs_student',
    },
    parent: {
      displayName: 'Parent/Guardian',
      value: 'parent',
    },
    advisor: {
      displayName: 'Career Coach/Advisor',
      value: 'advisor',
    },
    school: {
      displayName: 'School',
      value: 'school',
    },
    professional: {
      displayName: 'Working Professional',
      value: 'professional',
    },
  },
  possible_user_types: [
    {
      displayName: 'College Student',
      value: 'coll_student',
    },
    {
      displayName: 'High School Student',
      value: 'hs_student',
    },
    {
      displayName: 'Parent',
      value: 'parent',
    },
    {
      displayName: 'Admin',
      value: 'admin',
    },
    {
      displayName: 'Working Professional',
      value: 'professional',
    },
  ],
  wheel_chart_node_type: {
    CAREER: 'career',
    EDUCATION: 'education',
    TARGET: 'target',
    INITIAL: 'initial',
  },
  tutorialsFeedItems: {
    homePage: {
      post_title: 'Home Page',
      post_description:
        'Your home page is tailored to the interests you select, and allows you to view videos and infographics all from your Home Pages',
      source_code: 'https://www.youtube.com/watch?v=rnq7BCvs51s',
    },
    search360: {
      post_title: 'Get Started with Search360',
      post_description:
        'Learn more about your future career path by exploring the career paths of other professionals already on the path to success.',
      source_code: 'https://www.youtube.com/watch?v=c6oDQPX7d10',
    },
    educationBackground: {
      post_title: 'Education Background',
      post_description:
        'Learn more about the competitive landscape of your target job market to tailor your education to your future career.',
      source_code: 'https://www.youtube.com/watch?v=bsou_2jHN5c',
    },
    salaryAndCareer: {
      post_title: 'Salary and Career',
      post_description:
        "You'll face many difficult choices along the way to your dream career, and you should be armed with all the data available to ensure future financial independence.",
      source_code: 'https://www.youtube.com/watch?v=BD1azWBIvW8',
    },
    careerPaths: {
      post_title: 'Career Paths & Wheel View',
      post_description:
        "Sometimes reality can get lost in a sea of statistics. Use this module to view those who've walked the path before you.",
      source_code: 'https://www.youtube.com/watch?v=hyARfXQF3YA',
    },
    skills: {
      post_title: 'Skills',
      post_description:
        'Certain jobs require very specific skills. Start researching and learning now to boost your chances of landing a job in your chosen field.',
      source_code: 'https://www.youtube.com/watch?v=R8j5LKGJZhk',
    },
  },
  fullstoryClassNames: {
    currencyInput: 'currency-input',
    dateInput: 'date-input',
    searchbar: 'searchbar',
    selectInput: 'select-input',
    textAreaInput: 'textarea-input',
    textInput: 'text-input',
  },
}



// WEBPACK FOOTER //
// ./src/utils/constants/application.js